<template>
    <div class="card bs-5 mb-5">
        <div class="fl-te-c pb-3">
            <h4 v-html="'BLOG CATEGORY'"></h4>
            <div>
                <btn color="success" icon="fa fa-plus" size="md" @click="$refs.blogCategoryAddModal.show()" text="Add"/>
            </div>
        </div>
        <vue-table :fields="fields" :url="listUrl" :per-page="10" ref="table">
            <template #disabled="{rowData}">
                <checkbox-input v-model="rowData.disabled" @input="disable(rowData)"></checkbox-input>
            </template>
            <template #actions="{rowData}">
                <div class="btn-group-tight">
                    <delete-btn @click="setDelete(rowData)"/>
                    <edit-btn @click="setEdit(rowData)"/>
                </div>
            </template>
        </vue-table>

        <modal title="Add Blog Category" ref="blogCategoryAddModal" width="30r" :no-close-on-backdrop="true" header-color="primary">
            <AddBlogCategory @success="formSuccess"></AddBlogCategory>
        </modal>

        <modal title="Edit Blog Category" ref="blogCategoryEditModal" :no-close-on-backdrop="true" width="30r" header-color="primary">
            <EditBlogCategory :initial-data="editingItem" @success="formSuccess"></EditBlogCategory>
        </modal>

        <delete-modal ref="blogCategoryDeleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
            <p>You are about to delete the Blog <b v-html="deletingItem && deletingItem.title"></b>. Are you sure ?
            </p>

            <template #loading>
                <loading-animation/>
                Please wait while we delete <b v-html="deletingItem && deletingItem.id"></b>.
            </template>
        </delete-modal>

    </div>
</template>

<script>
import urls from '../../../../data/urls';
import axios from 'secure-axios';
import EditBlogCategory from './EditBlogCategory';
import AddBlogCategory from './AddBlogCategory';

export default {
    name       : 'Blog',
    components : { AddBlogCategory, EditBlogCategory },
    data () {
        return {
            listUrl      : urls.admin.blogCategory.list,
            deleteUrl    : urls.admin.blogCategory.delete,
            editingItem  : null,
            deletingItem : null,
            fields       : [
                {
                    name       : 'name',
                    sortField  : 'name',
                    title      : 'Name',
                    titleClass : ''
                },
                {
                    name       : '__slot:actions',
                    title      : 'Actions',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        formSuccess () {
            const refs = this.$refs;
            refs.blogCategoryAddModal.close();
            refs.blogCategoryEditModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            delete this.editingItem.description;
            this.editingItem.initial_description = item.description;
            this.$refs.blogCategoryEditModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.blogCategoryDeleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$notify('Successfully Deleted Blog Category..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$refs.blogCategoryDeleteModal.close();
            this.$refs.table.refreshTable();
        },

        disable (item) {
            const that = this;
            axios.form(urls.admin.blog.addEdit, item).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                    that.$notify('Successfully Updated Blog Category..!', 'Success',
                        {
                            type : 'success'
                        });
                } else {
                    that.$notify(json.errors, 'Error',
                        {
                            type : 'warning'
                        });
                    item.disabled = !item.disabled;
                }
            }).catch(function (err) {
                item.disabled = !item.disabled;
                console.log('error : ', err);
                that.$notify('Something went wrong..!', 'Success',
                    {
                        type : 'warning'
                    });
            });
        }
    }
};
</script>

<style scoped>

</style>
